export default __webpack_public_path__ + "static/media/small.9ac0f14a.jpg";